import React from 'react';
import BarkLogo from '@gumtree/ui-library/src/assets/bark-logo.svg';
import HintTooltip from '@gumtree/ui-library/src/hint-tooltip/hint-tooltip';
import { BarkLogoInfoContainer } from './index.style';

const BarkLogoInfo: React.FC = () => {
    return (
        <BarkLogoInfoContainer>
            <BarkLogo />
            <HintTooltip
                content="An Ad made in partnership with Bark."
                triggerColor="grey"
                closeBtnColor="lightGrey"
                theme="white"
                elName="bark"
                size='small'
                type='Bark'
            />
        </BarkLogoInfoContainer>
    );
}

export default BarkLogoInfo;
